/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { appPalette } from '@sidekick/design-tokens';
import { monoLabel } from '../lib/ui.js';

const p = appPalette;

/**
 * The top bar shared across every page: the localized date on the left
 * and a mono nav label on the right, separated from the content by a
 * bottom border.
 */
export function PageHeader({ label }: { label: string }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 22px',
        borderBottom: `1px solid ${p.line}`,
      }}
    >
      <span style={monoLabel}>
        {(() => {
          const d = new Date();
          return d.toLocaleDateString(undefined, {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
          });
        })()}
      </span>
      <span style={{ ...monoLabel, color: p.fg }}>{label}</span>
    </div>
  );
}
